import { render, staticRenderFns } from "./sela_castle_introduce.vue?vue&type=template&id=09eb7771&scoped=true"
import script from "./sela_castle_introduce.vue?vue&type=script&lang=js"
export * from "./sela_castle_introduce.vue?vue&type=script&lang=js"
import style0 from "./sela_castle_introduce.vue?vue&type=style&index=0&id=09eb7771&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eb7771",
  null
  
)

export default component.exports